export default __webpack_public_path__ + "static/media/BLog_01.01a8c96d.png";